export enum REDIRECT_SOURCE {
    LIBRARY = 'library',
    LESSON = 'lesson',
    JOURNAL = 'journal',
}
